import React from "react";
import "./reportcard.components.css"; 

interface ReportCardProps {
  color: string;
  title: string;
  count: number;
  nextDueDay: string;
  onClick: () => void;
}

const ReportCard: React.FC<ReportCardProps> = ({ color, title, count, nextDueDay, onClick }) => (
  <div className="card card-custom" style={{ borderLeftColor: color, cursor: "pointer" }} onClick={onClick}>
    <div className="card-body">
      <p className="card-title" style={{ color: color }}>
        {title}
      </p>

      {/* <div className="row d-flex align-items-end">
      <div className="me-auto">
        <h3 className="card-count" style={{ color: color }}>
          {count}
        </h3>
      </div>
      <div>
        <span className="card-status">reports</span>
      </div>
    </div> */}

<h3 className="card-count" style={{ color: "black" }}>{count} <span className="card-status">{`report${[0, 1].includes(count) ? '' : 's'}`}</span></h3>



      <hr/>

      <p className="card-due-day">Next due in {nextDueDay}</p>
    </div>
  </div>
);

export default ReportCard;
